import { Button } from "antd";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IconFilePdfSolid } from "../../../icon";
import { ActionTableState } from "../action-table/action-table";
import { useGetContractsQuery as getContractsQuery, useDeleteContractMutation } from "../../../api/plamo-api";


function ContractList({ contractObjectType, contractObjectId, navigationBasePath }) {
  const [deleteContract, { isLoading: isDeletingAssignment }] = useDeleteContractMutation()
  const navigate = useNavigate()
  const userToken = useSelector(state => (state as any).user?.userToken);

  const isLoading = isDeletingAssignment;
  
  const downloadPdf = useCallback(async contractId => {
    const response = await fetch(`/api/plamo/contract/${contractId}/unsigned-pdf`, { method: 'GET', headers: { 'Accept': 'application/pdf', 'Authorization': `Bearer ${userToken}` } });
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a") as any;
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = "Vertrag.pdf";
    a.click();
    window.URL.revokeObjectURL(url);
  }, [userToken])

  const columns = useMemo(() => [
    {
      title: "Id",
      dataIndex: "id",
      sorter: true,
      filter: true,
      type: 'int',
    },
    {
      title: "Titel",
      dataIndex: "title",
      sorter: true,
      filter: true,
    },
    {
      title: "Datum",
      dataIndex: "date",
      sorter: true,
      filter: true,
      type: 'date',
    },
    {
      title: "Vertragsdokument",
      dataIndex: "id",
      render: value => <Button onClick={() => downloadPdf(value)} icon={<IconFilePdfSolid />} />
    },
  ], [downloadPdf])

  const applyPreselectedToFilter = useCallback(f => {
    const obj = JSON.parse(f);
    obj.objectType = { c: "EQ", v: contractObjectType };
    obj.objectId = { c: "EQ", v: contractObjectId };
      
    return JSON.stringify(obj);
  }, [contractObjectId, contractObjectType])

  return (
    <ActionTableState
          isParentLoading={isLoading}
          buttonRow={{
            buttons: [
              {
                text: 'Neu',
                buttonType: 'primary',
                onClick: () => navigate(`${navigationBasePath}/new`)
              },
            ]
          }}
          tableData={{
            defaultSortKey: 'date',
            defaultSortDirection: 'desc',
            columns,
            dataSource: {
              pageableQueryEndpoint: ({ f, ...rest }) => getContractsQuery({ f: applyPreselectedToFilter(f), ...rest }),
              queryResultMapping: (result) => result?.items
            },
            actions: [
              {
                caption: 'Bearbeiten',
                onClick: (item) => navigate(`${navigationBasePath}/${item.id}`)
              },
              {
                caption: 'Löschen',
                danger: true,
                onClick: (item) => deleteContract(item),
                confirmTitle: _ => "Vertrag löschen?",
                confirmContent: _ => <>Soll der Vertrag wirklich gelöscht werden?</>
              }
            ]
          }}
        />
  )
}

export default ContractList;